import { NotificationType } from '~/app/enums/NotificationId';
import { SystemNotification } from '~/app/models/Notification';

/** Identity of a notification in the store: one notification per type and therapy job. */
export const notificationId = (type: NotificationType, therapyJobId: string): string => `${type}-${therapyJobId}`;

export const systemNotificationId = (notification: SystemNotification): string =>
  notificationId(NotificationType[notification.type], notification.therapyJobId);
